
import { postNewOneTimeRideForm, getSupervisorList, getBuilding, getDistrict } from '../api.js'

import notifications from '../notifications.js'


function _postNewOneTimeRideForm(content) {
  return postNewOneTimeRideForm(content)
    .then(response => {
      if (response.status === 201) {
        notifications.pushInfo('All validation complete, form submitted.')
        return response.data
      }
      else {
        throw new Error(response.data)
      }
    })
    .catch(error => {
      notifications.pushError(`Form submission failed! ${error.response.data}`, error)
    })
}

function _getSupervisorList() {
  return getSupervisorList()
    .then(response => {
      return response.data
    })
    .catch(error => {
      notifications.pushError('Error getting supervisor list.', error)
      throw error
    })
}

function _getDistrict() {
  return getDistrict()
    .then(response => {
      return response.data
    })
    .catch(error => {
      notifications.pushError('Error getting districts.', error)
      throw error
    })
}

function _getBuilding() {
  return getBuilding()
    .then(response => {
      return response.data
    })
    .catch(error => {
      notifications.pushError('Error getting buildings.', error)
      throw error
    })
}

function _canSubmitForm(user) {
  if (user === undefined) {
    return false
  }

  return user.can('submit_one_time_ride')
}

function _canViewInternalCstData(user) {
  if (user === undefined) {
    return false
  }

  return user.can('view_internal_cst_data')
}

function _init() {
  // do nothing
}

_init()

export default {
  getSupervisorList: _getSupervisorList,
  getDistrict: _getDistrict,
  getBuilding: _getBuilding,
  postNewOneTimeRideForm: _postNewOneTimeRideForm,
  canSubmitForm: _canSubmitForm,
  canViewInternalCstData: _canViewInternalCstData,
}
